import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { TabTitle } from '../../../../util/titleChanger';
import { GlobalState } from '../../../../GlobalState';
import { createNewWorkFlow, updateWorkFlow } from '../../../../action';
import { ToastContainer, toast } from 'react-toastify'
import Loading from '../../../../util/Loading'

export default function WorkFlowForm() {
    const { workflowId } = useParams();
    TabTitle(workflowId > 0 ? "Update Workflow" : "Create Workflow");
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    const [workflowDetail] = state.workflowAPI.workflowDetail;
    const [id, setId] = state.workflowAPI.id;
    const [callback, setCallback] = state.workflowAPI.callback;

    const [allStaffs] = state.staffAPI.allStaffs;

    const [btnName, setBtnName] = useState("Save");
    const [focused, setFocused] = useState(false);
    const [values, setValues] = useState([]);

    //For auto complete state
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [selectStaff, setSelectStaff] = useState("")
    const suggestions = allStaffs.filter(
        staff => staff.first_name.toString().toLowerCase().includes(selectStaff.toString().toLowerCase())
    )

    //Get value form input elements and assign into values states
    const handleSuggestionClick = (suggestion) => {
        setSelectStaff(suggestion.first_name + " " + suggestion.last_name)
        setShowSuggestions(false)
        setValues({
            ...values,
            staffId: suggestion.id
        })
    }

    const onChangeSelectStaff = (e) => {
        setSelectStaff(e.target.value)
    }

    //Focus input elements
    const handleFocus = (e) => {
        setFocused(true)
    }

    //Get value form input elements and assign into values states
    const onChangeValue = (e) => {
        e.preventDefault();
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        if (workflowId > 0) {
            setBtnName("Update");
            setId(workflowId);

            var today = new Date();
            var assign_date = new Date(workflowDetail.assign_date);

            setValues({
                ...values,
                work_type: workflowDetail ? workflowDetail.work_type : "",
                assign_route: workflowDetail ? workflowDetail.assign_route : "",
                note: workflowDetail ? workflowDetail.note : "",
                assign_date: workflowDetail.assign_date ? assign_date.toISOString().substring(0, 10) : today.toISOString().substring(0, 10),
                staffId: workflowDetail.staff ? workflowDetail.staff.id : 1
            })

            allStaffs.map(staff => {
                const staff_id = workflowDetail.staff ? workflowDetail.staff.id : 1;

                if (staff.id === staff_id) {
                    setSelectStaff(staff.first_name + " " + staff.last_name);
                }
            })
        }
    }, [allStaffs, id, workflowId, workflowDetail])

    const submitDefault = (e) => {
        e.preventDefault();

        const workflowInfo = {
            work_type: values.work_type,
            assign_route: values.assign_route,
            note: values.note,
            assign_date: values.assign_date,
            staffId: values.staffId,
            updatedBy: signInUser.id
        }

        if (workflowId > 0) {
            updateWorkFlow(workflowId, workflowInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data)
                    setCallback(!callback)
                } else {
                    toast.error(res.data)
                    setCallback(!callback)
                }
            })
        } else {
            workflowInfo.createdBy = signInUser.id
            createNewWorkFlow(workflowInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data)
                    setCallback(!callback)
                } else {
                    toast.error(res.data)
                    setCallback(!callback)
                }
            })
        }
    }

    return (
        !workflowDetail ? <div className="form-container"><div className="loading-page-container"><Loading /></div></div>
            : <div className="form-container">
                <header>Workflow Form</header>
                <form onSubmit={submitDefault} className="form">

                    <div className="input-box">
                        <label htmlFor="staffId">Staff Name</label>
                        <input
                            type="text"
                            name="staffId"
                            id="staffId"
                            placeholder='Enter Staff Name'
                            value={selectStaff}
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeSelectStaff}
                            onFocus={() => setShowSuggestions(true)}
                        />
                        {
                            showSuggestions && (
                                <ul className="suggestions">
                                    {
                                        suggestions.map(suggestion => (
                                            <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion)}>
                                                {suggestion.first_name + " " + suggestion.last_name}
                                            </li>
                                        ))
                                    }
                                </ul>
                            )
                        }
                    </div>

                    <div className="input-box">
                        <label htmlFor="work_type">Work Type</label>
                        <input
                            type="text"
                            name="work_type"
                            id="work_type"
                            placeholder='Enter Work Type'
                            value={values.work_type || ""}
                            required pattern='^(\w+\S+)$'
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeValue}
                        />
                        <span>Work type required</span>
                    </div>

                    <div className="input-box">
                        <label htmlFor="assign_route">Assign Route</label>
                        <input
                            type="text"
                            name="assign_route"
                            id="assign_route"
                            placeholder='Enter Assign Route'
                            value={values.assign_route || ""}
                            required pattern='^(\w+\S+)$'
                            onBlur={handleFocus}
                            focused={focused.toString()}
                            onChange={onChangeValue}
                        />
                        <span>Assign route required</span>
                    </div>

                    <div className="input-box">
                        <label htmlFor="assign_date">Assign Date</label>
                        <input
                            type="date"
                            name="assign_date"
                            id="assign_date"
                            value={values.assign_date || new Date().toISOString().substring(0, 10)}
                            onChange={onChangeValue}
                        />
                    </div>

                    <div className="input-box">
                        <label htmlFor="note">Description</label>
                        <textarea
                            name="note"
                            id="note"
                            cols="30" rows="5"
                            placeholder='Enter description here...'
                            value={values.note}
                            onChange={onChangeValue}
                        />
                    </div>

                    <div className="form-button">
                        <button className="add_new">{btnName}</button>
                    </div>
                </form>
                <ToastContainer />
            </div>
    )
}
